import React, { useEffect } from 'react';

function DefaultRulesContent() {
  return (
    <>
      <section>
        <h3>Placement Phase</h3>
        <p>
          Take turns placing your pieces on empty cells. Each player places 4
          pieces (8 turns total). Get three in a row to win during placement.
        </p>
      </section>
      <section>
        <h3>Shift Phase</h3>
        <p>
          When both players have placed all 4 pieces and nobody has won yet, the
          shift phase begins. Turns continue in the same order as placement. Tap
          one of your crosses or noughts, then an adjacent empty cell (including
          diagonals) to move it.
        </p>
        <p>
          Players take turns shifting one piece at a time. Each turn you move
          exactly one piece to an adjacent empty cell, then it is the other
          player&apos;s turn.
        </p>
      </section>
      <section>
        <h3>Winning</h3>
        <p>
          Align three of your pieces horizontally, vertically, or diagonally.
          There is no draw in the shift phase — keep playing until someone wins.
        </p>
      </section>
    </>
  );
}

function RulesModal({
  open,
  onClose,
  rules,
  title = 'How to Play',
  textStyle,
  themeColors = {},
}) {
  const listItemStyle = themeColors?.text_color
    ? { color: themeColors.text_color }
    : undefined;
  const buttonStyle =
    themeColors?.option_color != null && themeColors?.option_text_color != null
      ? {
          backgroundColor: themeColors.option_color,
          color: themeColors.option_text_color,
        }
      : undefined;
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const hasThemeRules = Array.isArray(rules) && rules.length > 0;

  return (
    <div
      className="game-rules-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="game-rules-title"
      onClick={onClose}
    >
      <div
        className="game-rules-modal"
        style={textStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="game-rules-modal__close"
          onClick={onClose}
          aria-label="Close rules"
        >
          ×
        </button>
        <h2 id="game-rules-title" className="game-rules-modal__title">
          {title}
        </h2>
        <div className="game-rules-modal__body">
          {hasThemeRules ? (
            <ul className="game-rules-modal__list">
              {rules.map((rule, index) => (
                <li key={`${index}-${rule.slice(0, 24)}`} style={listItemStyle}>
                  {rule}
                </li>
              ))}
            </ul>
          ) : (
            <DefaultRulesContent />
          )}
        </div>
        <button
          type="button"
          className="game-rules-modal__btn"
          style={buttonStyle}
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default RulesModal;
